import { SERVICE_LINE_NAMES } from '../config';
import {
  editPatient,
  getAllDopeRelatives,
  getAllRelatives,
  getDentalRelatives,
  getPatients,
  getRelatives,
  saveNewPatient,
  selectPatient,
  getPhysioRelatives,
} from '../services';
import { store } from '../store';
import clientConfig from '../clientConfig';

const {
  user: { authToken, userId },
} = store.getState();

// Clients with `useDopeRelatives` source the user's relatives from the dope
// endpoint (an external policy engine) instead of the app's own relatives list.
const getRelativesOrDope = (fallbackFn) =>
  clientConfig.useDopeRelatives ? () => getAllDopeRelatives(authToken) : fallbackFn;

const COMMON = {
  addFunction: (patientDetails) => saveNewPatient(patientDetails),
  editFunction: (patientDetails) => editPatient(patientDetails),
  getPatient: getRelativesOrDope((t) => getAllRelatives(authToken, t)),
  selectPatient: null,
  showEditPatient: false,
  showAddPatient: false,
  responseKey: 'patients',
  addSelfManually: false,
};

export const PATIENT_MODAL_CONFIG = {
  [SERVICE_LINE_NAMES.TELE]: { ...COMMON, responseKey: 'relatives' },

  [SERVICE_LINE_NAMES.OFFLINE]: {
    ...COMMON,
    getPatient: getRelativesOrDope(() => getAllRelatives(userId)),
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.PREBOOK]: {
    ...COMMON,
    getPatient: getRelativesOrDope(() => getAllRelatives(userId)),
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.LABS]: {
    ...COMMON,
    getPatient: (cartId, isConciergeBooking) =>
      getPatients(null, null, cartId, null, isConciergeBooking),
    selectPatient: (cartId, patientId) => selectPatient(cartId, patientId),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.PHARMACY]: {
    ...COMMON,
    getPatient: () => getPatients(),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.SEARCHBOOK]: {
    ...COMMON,
    getPatient: () => getPatients(),
    showEditPatient: true,
    showAddPatient: true,
    addSelfManually: false,
  },

  [SERVICE_LINE_NAMES.DENTAL]: {
    ...COMMON,
    getPatient: getRelativesOrDope(() => getDentalRelatives()),
    responseKey: 'relatives',
  },
  [SERVICE_LINE_NAMES.VISION]: {
    ...COMMON,
    responseKey: 'relatives',
  },

  [SERVICE_LINE_NAMES.PHYSIO]: {
    ...COMMON,
    // Not switched to dope: response shape is `userPolicyDetails` (policy-specific
    // fields), not the `relatives` shape the dope endpoint returns.
    getPatient: () => getPhysioRelatives(),
    responseKey: 'userPolicyDetails',
    selectPatient: (cartId, patientId) => selectPatient(cartId, patientId),
    showEditPatient: false,
    showAddPatient: false,
    addSelfManually: false,
  },
};
